import classNames from 'classnames';
import { Children, ComponentProps, Fragment, ReactNode } from 'react';

import wrapChildren from '../../helpers/react/wrapChildren';
import Space from '../../types/UI/Space';
import Box from '../Box/Box';

import styles from './Row.module.css';

type RowProps = {
    horizontal?: ComponentProps<typeof Box>['horizontal'];
    vertical?: ComponentProps<typeof Box>['vertical'];
    flex?: boolean | number;
    space?: Space;
    children?: ReactNode;
    spacer?: ReactNode;
    maxWidth100Percent?: boolean;
    reverse?: boolean;
};

const Row = ({
    space = 'medium',
    horizontal,
    vertical,
    maxWidth100Percent,
    flex,
    children,
    spacer,
    reverse,
}: RowProps) => {
    const spacerClasses = classNames(styles.Spacer, {
        [styles.Spacer_spaceXSmall]: space === 'xsmall',
        [styles.Spacer_spaceSmall]: space === 'small',
        [styles.Spacer_spaceMedium]: space === 'medium',
        [styles.Spacer_spaceLarge]: space === 'large',
        [styles.Spacer_spaceXLarge]: space === 'xlarge',
    });

    const nonEmptyChildren = Children.toArray(children).filter((x) => !!x);

    const style = flex ? { flex: flex === true ? 1 : flex } : undefined;

    return (
        <Box
            horizontal={horizontal}
            vertical={vertical}
            style={style}
            maxWidth100Percent={maxWidth100Percent}
            reverse={reverse}
        >
            {wrapChildren(nonEmptyChildren, (child, key, index) => {
                return (
                    <Fragment key={key}>
                        {index !== 0 && (space !== 'none' || spacer) && (
                            <span className={spacerClasses}>{spacer}</span>
                        )}
                        {child}
                    </Fragment>
                );
            })}
        </Box>
    );
};

export default Row;
